import store from 'Store'
import axios from 'axios'
import config from './config'
import { loadCurretUser } from './helpers'

const currentUser = loadCurretUser()

const apiClient = axios.create({
  baseURL: config.baseURL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 30000,
})

// Requests interceptors
apiClient.interceptors.request.use(
  (config) => {
    if (currentUser) {
      // Set token if user's logged in
      config.headers.common.Authorization = `Token ${currentUser.token}`
    }
    // if (DEV) {
    //   console.info('ApiConfig ⚙️ ', config)
    // }
    return config
  },
  (error) => {
    if (config.DEV) {
      console.error('❗️ ', error)
    }
    return Promise.reject(error)
  }
)
// Response interceptors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Checking Unauthorized user
      if (error.response.status === 401) {
        store.dispatch('user/logout')
      }
    }
    return Promise.reject(error)
  }
)

export { apiClient }
